import toast from "react-hot-toast";
import * as api from "../Api";
import { newInvestments } from "./newInvestments";

export const createUndefinedInvestment = (postData) => async (dispatch) => {
  const savingId = toast.loading("Submitting investment for approval...");
  try {
    const { data } = await api.createInvestment(postData);
    dispatch({ type: "CREATE_UNDEFINED_INVESTMENT", payload: data });
    // It now waits on the Approvals page
    dispatch(newInvestments());
    toast.remove(savingId);
    toast.success("Submitted for approval");
    return data;
  } catch (error) {
    toast.remove(savingId);
    toast.error(
      error?.response?.data?.message || error?.message || "Something went wrong",
    );
    throw error;
  }
};
export const getUndefinedInvestments = () => async (dispatch) => {
  try {
    const { data } = await api.getUndefinedInvestments();
    dispatch({ type: "GET_ALL_UNDEFINED_INVESTMENTS", payload: data });
  } catch (error) {}
};
